import { getKvSyncApi } from '@/api/kvSync'
import kvSyncSubscriber from '@/mqtt/kvSync'

const _state = {}

const kvSyncApi = () => {
  return getKvSyncApi()
}

const actions = {
  fetchValueByKeyAction: async ({ dispatch }, payload) => {
    if (!payload.key) return
    const resp = await kvSyncApi().getValueByKey(payload.key)
    const { value } = resp.body
    dispatch('updateKeyValueAction', {
      key: payload.key,
      value,
    })
  },

  createKeyValueAction: async (_, payload) => {
    await kvSyncApi().createKeyValue(payload)
  },

  subscribeKeyAction: async ({ dispatch }, payload) => {
    // wildcard key has no literal value, so skip the empty fetch
    if (!payload.key?.endsWith('/#')) {
      dispatch('fetchValueByKeyAction', payload)
    }
    kvSyncSubscriber.subscribeKey(payload.key, (topic, message) => {
      dispatch('updateKeyValueAction', {
        key: topic,
        value: message,
      })
      if (payload.callback) {
        payload.callback(topic, message)
      }
    }, payload.options)
  },

  updateKeyValueAction: () => { }, // only declare the action, plugins will listen to this to update state accordingly

  unsubscribeKeyAction(_, payload) {
    kvSyncSubscriber.unsubscribeKey(payload)
  },
}

export default {
  namespaced: true,
  state: _state,
  actions,
}
